/* @flow */

export const SET_NEW_TOPIC_READY = 'SET_NEW_TOPIC_READY';
export const UNSET_NEW_TOPIC_READY = 'UNSET_NEW_TOPIC_READY';
